module.exports = {
  tableTitle: '最近10条历史查询任务',
  tableCol1: '序号',
  tableCol2: 'ID',
  tableCol3: '任务创建时间',
  tableCol4: '任务开始时间',
  tableCol5: '任务结束时间',
  tableCol6: '操作',
  tableCol7: '文件名',
  downloading: '生成中',
  downloadErr: '下载失败'
}
